<template lang="pug">
  div
    v-card.py-3(tile flat)
      div.d-flex.align-center.px-4.py-2
        div
          div.h6.basic800--text {{ lead.products.reduce((sum, p) => { return sum + (p.price_per_set * p.quantity) }, 0) | displayPrice }}
          div.c1.danger500--text(v-if="day === 'today'" style="margin-top: 2px") {{ checkTodayTime(lead.created) }}
          div.c1.danger500--text(v-else style="margin-top: 2px") {{ $t('yesterday_at') }} {{ lead.created | displayTime }}
        v-spacer
        v-btn.button-AA-small(v-if="source === 'tbcontacted'" color="info500" small height="32" dark @click="clickContact" :loading="isLoading")
          v-icon(small left) mdi-whatsapp
          | {{ $t('contact') }}
        v-btn.button-AA-small(v-else color="primary" outlined small height="32" style="background-color: var(--v-basic600T08" @click="clickContact")
          v-icon(small left) mdi-whatsapp
          | {{ $t('contact') }}
      v-divider.basic300.mx-4
      div.px-4.mt-2
        div.p2.primary--text {{ lead.name }}
        div.d-flex.align-center
          div.p2.basic600--text {{ itemQuantity > 1 ? itemQuantity + ' items' : itemQuantity + ' item'  }}
          v-spacer
          div.c1.basic600--text {{ `#${lead.rid}` }}
      
      div.px-4.mt-2
        div.d-flex.align-center(v-if="details.customerPhone || details.source")
          template(v-if="details.customerPhone")
            div.p2.basic700--text.mb-1(v-if="details.customerPhone") {{ ((lead.shipping_address && lead.shipping_address.phone) || lead.phone) | phoneFormat }}
            v-spacer
          div.c1.basic600--text.mb-1(v-if="details.source") {{ lead.form.type === 'store' ? 'Yezza Store' : lead.form.name }}

        div.p2.basic700--text.mb-1(v-if="details.customerEmail && lead.email") {{ lead.email }}
            
        .customer-selection(v-if="details.shippingMethod || details.scheduledDateTime || details.address")
          div.c1.basic600--text.mb-1 {{ $t('customer_selection') }}:
          div.d-flex.align-center.mb-1(v-if="details.shippingMethod && lead.shipping")
            eva-icon.mb-n1.mr-1(name="car-outline" :fill="$vuetify.theme.themes[$theme].basic700" width="15" height="15")
            div.p2.basic700--text(v-if="lead.pickup") {{ $t('self_pickup') }}
            div.p2.basic700--text(v-else) {{ lead.shipping.shipping_method | shippingMethodDisplay }}

          div.d-flex.align-center.mb-1(v-if="details.scheduledDateTime && (lead.asking_delivery_date || lead.asking_delivery_time)")
            eva-icon.mb-n1.mr-1(name="clock-outline" :fill="$vuetify.theme.themes[$theme].basic700" width="15" height="15")
            div.p2.basic700--text(v-if="lead.asking_delivery_date") {{ lead.asking_delivery_date | displayDate }}
              span.ml-1(v-if="lead.asking_delivery_time") at {{ lead.asking_delivery_time | displayTime }}

          v-row.mb-1(no-gutters v-if="details.address && lead.shipping_address && !lead.pickup")
            v-col.shrink.pr-1
              eva-icon.mb-n1(name="pin-outline" :fill="$vuetify.theme.themes[$theme].basic700" width="15" height="15")
            v-col.pr-6(cols="10")
              div.p2.basic700--text(style="margin-top: 1px;") {{ lead.shipping_address.address_1 }}, {{ lead.shipping_address.address_2 ? lead.shipping_address.address_2 + ', ' : ' ' }}{{ lead.shipping_address.postcode }},{{ lead.shipping_address.area ? ` ${lead.shipping_address.area}, ${lead.shipping_address.suburb},` : '' }} {{ lead.shipping_address.city }}, {{ lead.shipping_address.state }}, {{ lead.shipping_address.country }}.

          div.d-flex.align-center.mb-1(v-if="details.paymentMethod && lead.order_remarks && lead.order_remarks.payment_method")
            eva-icon.mb-n1.mr-1(name="credit-card-outline" :fill="$vuetify.theme.themes[$theme].basic700" width="15" height="15")
            div.p2.basic700--text {{ lead.order_remarks.payment_method.display_name }}
        
        div.d-flex.mt-4.mb-2(v-if="details.amountPaid && lead.products.length > 0")
          div.c1.basic700--text {{ itemQuantity > 1 ? itemQuantity + ' items' : itemQuantity + ' item'  }}
          div.c1.basic700--text.ml-4 {{ lead.products.reduce((sum, p) => { return sum + (p.price_per_set * p.quantity) }, 0) | displayPrice }} {{ !lead.paid ? 'unpaid' : '' }}
        
        template(v-if="details.itemsOrdered && lead.products.length > 0")
          v-divider.basic300.my-2
          div(v-for="(p, index) in lead.products")
            div.d-flex(:key="p.id" :class="index + 1 === lead.products.length ? 'mb-2' : 'mb-1'")
              div.c1.primary500--text {{ p.quantity }} x
              div.ml-3
                div.c2.primary500--text {{ p.name }}
                div.c1.mb-0.primary400--text(v-if="p.addons.length > 0") (
                  span(v-for="(a, idx) in p.addons" :key="a.id") + {{ a.name }}{{ a.quantity_per_set > 1 ? ' x ' + a.quantity_per_set : '' }}{{ (idx + 1) < p.addons.length ? '; ' : '' }}
                  | )
              v-spacer
              div
                div.c1.primary400--text {{ p.price_per_set * p.quantity | displayPrice }}
        
        template(v-if="details.orderMessage && lead.order_remarks && lead.order_remarks.order_message")
          v-divider.basic300.mb-2
          div.c1.basic600--text.mb-2 {{ $t('message') }}: {{ lead.order_remarks.order_message }}

        template(v-if="details.remarks && lead.remarks")
          v-divider.basic300.mb-2
          div.c1.basic600--text.mb-2 {{ $t('remarks') }}: {{ lead.remarks }}

        template(v-if="details.extraInfo && lead.extra_fields_data && lead.extra_fields_data.length > 0")
          v-divider.basic300.mb-2
          div.c1.primary--text.mb-1(v-for="field in lead.extra_fields_data" style="white-space: pre-wrap;") {{ field.name }}: {{ field.value }}

</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import OrderItemDetails from '@/components/dialogs/order/OrderItemDetails.vue'

export default {
  name: 'FollowUpItem',
  props: ['parentLead', 'menu', 'source', 'company', 'messageTemplate', 'day'],
  components: { OrderItemDetails },
  data: () => ({
    intervals: [
      { label: 'year', seconds: 31536000 },
      { label: 'month', seconds: 2592000 },
      { label: 'day', seconds: 86400 },
      { label: 'hour', seconds: 3600 },
      { label: 'minute', seconds: 60 },
      { label: 'second', seconds: 1 }
    ],
    isLoading: false
  }),
  computed: {
    ...mapState('user', ['member']),
    ...mapGetters({
      details: 'followup/getFollowUpDetails'
    }),
    lead: {
      get() {
        return this.parentLead
      },
      set(newValue) {
        this.$emit('edited', newValue)
      }
    },
    itemQuantity () {
      if (this.lead && this.lead.products.length > 0) {
        return this.lead.products.reduce((sum, p) => { return sum + (p.quantity) }, 0)
      }
      return 0
    }
  },
  mounted () {},
  methods: {
    ...mapActions(['showMessage']),
    clickContact () {
      if (!this.Auth('component', '/admin/follow-up#follow_up_action')) {
        this.$emit('openSubscribe')
        return
      }
      this.isLoading = true
      let productMessage = ''
      let fieldsMessage = ''
      let storeUrl = ''
      let count = 1
      this.lead.products.forEach((prod) => {
        if (prod.addons.length > 0) {
          let addmsg = ''
          prod.addons.forEach((addon) => {
            addmsg = addmsg.concat(` - ${encodeURIComponent(addon.name)} x${addon.quantity_per_set}%0d%0a`)
          })
          productMessage = productMessage.concat(`${count}. ${encodeURIComponent(prod.name)} (x${prod.quantity})%0d%0a${addmsg}`)
        } else {
          productMessage = productMessage.concat(`${count}. ${encodeURIComponent(prod.name)} (x${prod.quantity})%0d%0a`)
        }
        count++
      })
      if (this.lead.extra_fields_data) {
        this.lead.extra_fields_data.forEach((field) => {
          if (field.send && field.value) {
            fieldsMessage = fieldsMessage.concat(`${encodeURIComponent(field.name)}: ${encodeURIComponent(field.value)}%0d%0a`)
          }
        })
      }
      let finalFieldsMessage = ''
      if (fieldsMessage.length > 0) {
        finalFieldsMessage = `%0d%0a%0d%0a${fieldsMessage}`
      }

      if (this.$subdomain) {
        storeUrl = `${this.$subdomain}.${process.env.VUE_APP_SHORT_URL_DOMAIN}/invoices/${this.lead.pid}`
      } else {
        storeUrl = `http://localhost:8080/invoices/${this.lead.pid}`
      }

      let message = `Hi ${this.lead.name},%0d%0a%0d%0astill interested to buy%0d%0a${productMessage}${finalFieldsMessage}?%0d%0a%0d%0a Order here : ${storeUrl}`
      message = this.$options.filters.encodeSymbols(message)
      if (this.messageTemplate) {
        message = this.messageTemplate
        message = message.split('{{name}}').join(this.lead.name ? encodeURIComponent(this.lead.name) : '')
        message = message.split('{{phone}}').join(this.lead.phone ? this.lead.phone : '')
        message = message.split('{{email}}').join(this.lead.email ? this.lead.email : '')
        message = message.split('{{products_description}}').join(productMessage || '')
        message = message.split('{{store_link}}').join(storeUrl || '')

        let largestIndex = 0
        message.split('{{').forEach((word) => {
          word.split('}}').forEach((w) => {
            if (w.includes('extra_')) {
              const index = parseInt(w.split('_')[1])
              if (largestIndex < index) {
                largestIndex = index
              }
            }
          })
        })
        for (let i = 0; i < largestIndex + 1; i++) {
          if (this.lead.extra_fields_data && this.lead.extra_fields_data.length > i) {
            const field = this.lead.extra_fields_data[i]
            message = message.split(`{{extra_${i}}}`).join(field.value ? encodeURIComponent(field.value) : '')
          } else {
            message = message.split(`{{extra_${i}}}`).join('')
          }
        }

        message = message.split(/\n/g).join('%0d%0a')
        message = this.$options.filters.encodeSymbols(message)
      }

      window.open(`https://api.whatsapp.com/send?phone=${this.lead.phone}&text=${message}`)

      this.$axios.patch(`/leads/${this.lead.pid}/taggings/contacted`)
        .then(resp => {
          if (this.lead.taggings.filter(f => f.tagging === 'contacted').length > 0) {
            this.lead.taggings.filter(f => f.tagging === 'contacted')[0] = resp.data
          } else {
            this.lead.taggings.push(resp.data)
          }
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    checkTodayTime (date) {
      if (typeof date !== 'object') {
        date = new Date(date)
      }
      const seconds = Math.floor((Date.now() - date.getTime()) / 1000)
      if (seconds < 0) {
        throw new Error('Current time is smaller than given datetime')
      }
      const interval = this.intervals.find(i => i.seconds < seconds)
      const count = Math.floor(seconds / interval.seconds)
      return `${count} ${interval.label}${count !== 1 ? 's' : ''} ago`
    }
  }
}
</script>

<style scoped>
.order-title:hover{
  text-decoration: underline;
  cursor: pointer;
}
.border-bottom{
  border-bottom: 1px solid var(--v-basic300);
  border-radius: 0 !important;
}
</style>